// @ts-check
import BoostedOddItemModel from '../boosted-odd/boosted-odd-item.model';
import TopEventsMatchModel from '../top-events/top-events-match.model';
import BannerItemModel from './banner-item.model';

export default class CombinedSliderModel {
  /**
   * @param {import('./interface').ApiCombinedSlider} data - combinedSlider object
   */
  constructor(data) {
    /**
     * Combined slider items
     * @type {import('./interface').ICombinedSliderType[]}
     */
    this.items = concatAndOrderItems(data);
  }
}

/**
 * 
 * @param {import('./interface').ApiCombinedSlider} data
 * @returns
 */
function concatAndOrderItems(data) {
  let combinedSliderArray = [];
  const topEventsItems = data.te.map(i => new TopEventsMatchModel(i));
  const boostedItems = data.bo.map(i => new BoostedOddItemModel(i));
  const bannerItems = data.be.map(i => new BannerItemModel(i));

  combinedSliderArray = combinedSliderArray.concat(boostedItems, topEventsItems, bannerItems);

  combinedSliderArray.sort((a, b) => a.orderNumber - b.orderNumber);

  return combinedSliderArray;
}